export default __webpack_public_path__ + "9f591978d2ca3fc58b24f5bfd2f64ccd.webp";